import { createSlice } from '@reduxjs/toolkit'

interface ErrorState {
  show: boolean
}

const initialState: ErrorState = {
  show: false,
}

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    showError: (state) => {
      state.show = true
    },
    hideError: (state) => {
      state.show = false
    },
  },
})

export const { showError, hideError } = errorSlice.actions
export default errorSlice.reducer
